import api from "../api";

export default class DeleteService {
    static removeDocument(document_id) {return api.delete(`projects/documents/${document_id}`).catch(e=>{ console.log(e);})}
}